export const InitScriptChatBot = (props, callback) => {

    let room = localStorage.getItem("room");

    const script = document.createElement('script');
    script.src = room && room != "null" ? props.freshChatData.logout.loadScript : props.freshChatData.login.loadScript;

    if(room && room != "null"){
        if (props.freshChatData.login.attributes && Object.keys(props.freshChatData.login.attributes).length > 0) {
            for (const [key, value] of Object.entries(props.freshChatData.login.attributes)) {
                script.setAttribute(key, value);
            }
        }
    } else {
        if (props.freshChatData.logout.attributes && Object.keys(props.freshChatData.logout.attributes).length > 0) {
            for (const [key, value] of Object.entries(props.freshChatData.logout.attributes)) {
                script.setAttribute(key, value);
            }
        }
    }

    script.async = true;

    script.onload = () => {
        console.log("Chat Bot Initialized successsfully");
    };

    script.onerror = (err) => {
        console.log("Something went wrong while initalising innspirechatbot" + JSON.stringify(err))
    }

    callback(true);
    document.head.appendChild(script);
}